(function () {
  var NEW_API = 'https://api-shop.pawidols.com';
  var OLD_API = 'https://api-shop.pawidols.com/dashboard/product-view/';

  var ref = new URLSearchParams(location.search).get('r');
  if (!ref) return;

  // ── Console debug ────────────────────────────────────────────────
  fetch(OLD_API + ref)
    .then(function (r) { return r.json(); })
    .then(function (json) { console.log('[Старий API]', json); })
    .catch(function (err) { console.error('[Старий API] Помилка:', err); });

  fetch(NEW_API + '/dashboard/product-view/' + ref)
    .then(function (r) { return r.json(); })
    .then(function (json) {
      console.log('[Новий API]', json);
      if (!json.success || !json.data) return;
      var d = json.data;

      if (d.mosaicList) {
         
        preloadAndShowMosaic(d.mosaicList);
      } else {
        
        showBlock('gallery');
      }
    })
    .catch(function (err) {
      console.error('[Новий API] Помилка:', err);
      showBlock('gallery'); // fallback
    });

   
  function showBlock(type) {
    var loadingWrapper = document.getElementById('CmbLoadingWrapper');
    var mosaicWrapper  = document.getElementById('CmbMosaicWrapper');
    var galleryWrapper = document.getElementById('CmbGalleryWrapper');

    if (loadingWrapper) loadingWrapper.remove();

    if (type === 'mosaic') {
       
      if (galleryWrapper) galleryWrapper.remove();
      if (mosaicWrapper)  mosaicWrapper.style.display = 'block';
    } else {
      
      if (mosaicWrapper)  mosaicWrapper.remove();
      if (galleryWrapper) galleryWrapper.style.display = 'block';
    }
  }

  
  function preloadAndShowMosaic(mosaicList) {
    var months  = Object.keys(mosaicList);
    var total   = months.length;
    var done    = 0;
    var imgMap  = {}; // month → Image

    months.forEach(function (month) {
      var url = mosaicList[month];
      if (!url) { done++; tryReveal(); return; }

      var img = new Image();
      imgMap[month] = { img: img, url: url };
      img.onload  = function () { done++; tryReveal(); };
      img.onerror = function () { done++; tryReveal(); };
      img.src = url;
    });

    function tryReveal() {
      if (done < total) return;

      
      var grid = document.querySelector('.cal-mosaic-block__grid');
      if (grid) {
        months.forEach(function (month, idx) {
          var card  = grid.querySelector('.cmb-card[data-index="' + idx + '"]');
          if (!card) return;
          var photo = card.querySelector('.cmb-card__photo');
          if (!photo) return;

          var entry = imgMap[month];
          var ph    = photo.querySelector('[data-placeholder]');
          if (ph) ph.remove();

          if (entry && entry.img.naturalWidth > 0) {
            entry.img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;transition:transform 0.35s ease;';
            entry.img.alt = month;
            photo.appendChild(entry.img);
            photo.dataset.fullSrc = entry.url;
          }
        });
      }

       
      showBlock('mosaic');

      if (typeof window.cmbCacheMosaicUrls === 'function') window.cmbCacheMosaicUrls();
      if (typeof window.cmbRebuildThumb    === 'function') window.cmbRebuildThumb();
    }
  }

})();
